import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Label } from "@/components/ui/label";
import { Code, Lightbulb, Scale } from "lucide-react";

interface CreativitySelectorProps {
  value: string;
  onValueChange: (value: string) => void;
}

export const CreativitySelector = ({ value, onValueChange }: CreativitySelectorProps) => {
  return (
    <div className="space-y-2">
      <Label>Response Style</Label>
      <ToggleGroup 
        type="single" 
        value={value} 
        onValueChange={onValueChange}
        className="justify-start"
      >
        <ToggleGroupItem value="technical" aria-label="More technical">
          <Code className="h-4 w-4 mr-2" />
          Technical
        </ToggleGroupItem>
        <ToggleGroupItem value="neutral" aria-label="Neutral">
          <Scale className="h-4 w-4 mr-2" />
          Neutral
        </ToggleGroupItem>
        <ToggleGroupItem value="creative" aria-label="More creative">
          <Lightbulb className="h-4 w-4 mr-2" />
          Creative
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};